import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/image/Google.svg")